// removed by extract-text-webpack-plugin
module.exports = {"quoteBoxWrap":"qempo_QuoteBox_quoteBoxWrap-32QGL9y","title":"qempo_QuoteBox_title-1MQbKe6","loadingWrap":"qempo_QuoteBox_loadingWrap-FnexNFo","loading":"qempo_QuoteBox_loading-2XG_q_v"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/ProductStep/components/NewProductForm/QuoteBox/QuoteBox.scss
// module id = 1623
// module chunks = 0